import { formatDistanceToNow } from 'date-fns';
import { formatInstantInTimezone, getDisplayTimezone } from '@/utils/timezone';

interface TimeAgoProps {
  timestamp: string;
  className?: string;
}

export function TimeAgo({ timestamp, className }: TimeAgoProps) {
  const date = new Date(timestamp);
  const timeAgo = formatDistanceToNow(date, { addSuffix: true });
  const title = formatInstantInTimezone(
    date,
    getDisplayTimezone(),
    { dateStyle: 'medium', timeStyle: 'short' }
  );

  return (
    <span className={className} title={title}>
      {timeAgo}
    </span>
  );
}
